import React from "react";
import '../index.css';
import TopBar from "../components/TopBar";
import SideBar from "../components/sidebars/HRSidebar";
import Staff from "../pages/Staff";

function SalariesLayout(){
    return (
    <div className="d-flex flex-column" id="kt_app_root">
      {/* Top Navbar */}
      <TopBar />

      {/* Dashboard content container */}
      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <SideBar />

        {/* Main Content Area */}
        <div className="flex-grow-1 p-4">
            <Staff />
        </div>
      </div>
    </div>

    );
}

export default SalariesLayout;